export default "__VITE_ASSET__EgIG5o2D__"